'use client'

import { useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import LogixboardSolutionImg from '@public/images/logixboard-case-study/logixboard-solution.png'
import PlaceHolder from '@public/images/placeholders/placeholder485x560.png'
import Image from 'next/image'
import { FC } from 'react'

import OverflowImage from '@/components/OverflowImage'
import TitleAndParagraph from '@/components/TitleAndParagraph'
import TwoColumnLayout, { ColumnWrapOrder } from '@/components/TwoColumnLayout'

const LogixboardSolution: FC<{}> = () => {
    const { smScreen } = useDevice()

    return (
        <Box
            sx={{
                position: 'relative',
            }}
        >
            <TwoColumnLayout
                leftCol={5}
                rightCol={6}
                columnWrapOrderOnMobile={ColumnWrapOrder.REVERSE}
            >
                <OverflowImage
                    float={`right`}
                    containerSx={{
                        ...(smScreen
                            ? {
                                  height: '400px !important',
                              }
                            : {}),
                    }}
                    placeholder={
                        <Image
                            width={485}
                            height={560}
                            src={PlaceHolder}
                            alt={'placeholder'}
                            style={{
                                opacity: 0,
                                ...(smScreen
                                    ? {
                                          height: '400px',
                                      }
                                    : {}),
                            }}
                        />
                    }
                >
                    <Image
                        width={860}
                        height={560}
                        // TODO: Add higher resolution image
                        src={LogixboardSolutionImg}
                        alt={'Logixboard solution'}
                        style={{
                            ...(smScreen
                                ? {
                                      height: '100%',
                                      objectFit: 'scale-down',
                                      objectPosition: 'right',
                                  }
                                : {}),
                        }}
                    />
                </OverflowImage>
                <TitleAndParagraph
                    title={`Solution`}
                    paragraph={
                        <span>
                            Logixboard needed a quick solution that empowered Freight Forwarders to
                            check the box for shipment emission estimates in tenders. They had three
                            core requirements:
                            <br />
                            <br />
                            1. To fit it into their product roadmap the solution had to be
                            easy-to-integrate <br />
                            2. To help them navigate a new space they needed an expert partner{' '}
                            <br />
                            3. To not overwhelm freight forwarders and their customers, they only
                            wanted to provide useful data
                            <br />
                            <br />
                            Logixboard propels its customers forward. So while their customers were
                            familiar with the market legacy solution, it did not match their
                            commitment to modern, efficient, and long-term solutions. This is why
                            they chose Lune — for their expertise, quick integration, and customer
                            service.
                            <br />
                            <br />
                            Logixboard’s engineers raved about the ease of implementation of Lune’s
                            emission intelligence. Its modern API meant customers only got the
                            shipment emissions data they needed to win tenders. Lune’s partnership
                            team was also available to advise on what data was needed to fulfil
                            information requests. The result was a modern, useful solution for
                            Logixboards customers.
                        </span>
                    }
                />
            </TwoColumnLayout>
        </Box>
    )
}

export default LogixboardSolution
